import { DatastoreInterface } from '@freelancer/datastore/core';
import { average } from '@freelancer/datastore/core/fake/mocks/random';
import {
  ProjectStatusApi,
  ProjectSubStatusApi,
  ProjectTypeApi,
} from 'api-typings/projects/projects';
import { Bid } from '../bids/bids.model';
import { CurrencyCode } from '../currencies/currencies.mock';
import { generateProjectObject } from '../projects/projects.mock';
import { ProjectViewProject } from './project-view-projects.model';
import { ProjectViewProjectsCollection } from './project-view-projects.types';

export interface GenerateProjectViewProjectOptions {
  readonly ownerId: number;
  readonly projectId?: number;
  readonly projectType?: ProjectTypeApi;
  readonly currencyCode?: CurrencyCode;
  readonly status?: ProjectStatusApi;
  readonly subStatus?: ProjectSubStatusApi;
  readonly selectedBids?: ReadonlyArray<Bid>;
  readonly activate?: boolean;
}

export async function createProjectViewProject(
  datastore: DatastoreInterface,
  options: GenerateProjectViewProjectOptions,
) {
  const object = generateProjectViewProjectObject(options);
  await datastore.createDocument('projectViewProjects', object);
  return object;
}

const defaultProjectViewProjectDetails = {
  attachments: [],
  canPostReview: {},
  description:
    'I need someone to make me a website for my business. It should be awesome and wiz bang.',
  location: {
    country: {
      id: '',
      code: '',
      name: '',
    },
  },
  qualifications: [],
  jobs: [
    {
      id: 3,
      name: 'PHP',
      category: {
        id: 1,
        name: 'Websites, IT & Software',
      },
      local: false,
      seoUrl: 'php',
      activeProjectCount: 0,
    },
  ],
  ndaDetails: {
    signatures: [],
  },
};

export function generateProjectViewProjectObject(
  options: GenerateProjectViewProjectOptions,
): ProjectViewProject {
  return {
    ...generateProjectObject(options),
    ...defaultProjectViewProjectDetails,
  };
}

// ----- Update -----

interface UpdateProjectViewBidAverageProjectOptions {
  readonly projectId: number;
  readonly bids: ReadonlyArray<Bid>;
}

export async function updateProjectViewProjectBidStats(
  datastore: DatastoreInterface,
  { projectId, bids }: UpdateProjectViewBidAverageProjectOptions,
) {
  return datastore
    .document<ProjectViewProjectsCollection>('projectViewProjects', projectId)
    .update({
      bidStats: {
        bidCount: bids.length,
        bidAvg: average(bids.map(bid => bid.amount)),
      },
    });
}
